import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { api, errMsg, mediaUrl } from "@/lib/api";
import { useSettings } from "@/lib/providers";
import { Switch } from "@/components/ui/switch";
import { ACard, AH1, AField, ABtn } from "./ui";

const Section = ({ title, children }) => (
  <ACard className="space-y-4">
    <h2 className="font-heading font-bold text-lg">{title}</h2>
    <div className="grid sm:grid-cols-2 gap-4">{children}</div>
  </ACard>
);

export default function AdminSettings() {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  const { setSettings } = useSettings();
  useEffect(() => { api.get("/admin/settings").then((r) => setF(r.data)); }, []);
  if (!f) return <Loader2 className="animate-spin" />;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const fld = (k, label, extra = {}) => <AField key={k} label={label} value={f[k] || ""} onChange={set(k)} testid={`settings-${k.replace(/_/g, "-")}`} {...extra} />;

  const uploadImg = async (file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    try { const { data } = await api.post("/admin/upload-image", fd); setF((p) => ({ ...p, instructor_image: data.url })); } catch (e) { toast.error(errMsg(e)); }
  };
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/admin/settings", f); setF(data); setSettings(data); toast.success("تم حفظ الإعدادات"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6 pb-20" data-testid="admin-settings">
      <AH1 action={<ABtn onClick={save} disabled={busy} data-testid="settings-save-btn">{busy && <Loader2 size={15} className="animate-spin" />}حفظ الإعدادات</ABtn>}>الإعدادات</AH1>
      <Section title="طرق الدفع">
        <label className="flex items-center gap-3 text-sm sm:col-span-2"><Switch checked={!!f.vodafone_enabled} onCheckedChange={(v) => setF({ ...f, vodafone_enabled: v })} data-testid="settings-vodafone-enabled" />تفعيل فودافون كاش</label>
        {fld("vodafone_number", "رقم فودافون كاش", { dir: "ltr" })}
        <div />
        <label className="flex items-center gap-3 text-sm sm:col-span-2"><Switch checked={!!f.instapay_enabled} onCheckedChange={(v) => setF({ ...f, instapay_enabled: v })} data-testid="settings-instapay-enabled" />تفعيل إنستاباي</label>
        {fld("instapay_number", "رقم إنستاباي", { dir: "ltr" })}
        {fld("instapay_handle", "عنوان إنستاباي (IPA) — اختياري", { dir: "ltr", placeholder: "name@instapay" })}
        {fld("payment_instructions", "تعليمات الدفع", { textarea: true, className: "sm:col-span-2" })}
      </Section>
      <Section title="التواصل والسوشيال">
        {fld("whatsapp_number", "رقم واتساب الدعم", { dir: "ltr" })}
        {fld("contact_phone", "رقم التليفون", { dir: "ltr" })}
        {fld("contact_email", "البريد الإلكتروني للتواصل", { dir: "ltr" })}
        {fld("address", "العنوان (اختياري)")}
        {fld("facebook_url", "رابط فيسبوك", { dir: "ltr" })}
        {fld("instagram_url", "رابط إنستجرام", { dir: "ltr" })}
        {fld("youtube_url", "رابط يوتيوب", { dir: "ltr" })}
      </Section>
      <Section title="المدرب">
        {fld("instructor_name", "اسم المدرب")}
        {fld("instructor_title", "المسمى المهني")}
        {fld("instructor_bio", "نبذة", { textarea: true, className: "sm:col-span-2" })}
        <div className="sm:col-span-2 flex items-center gap-3">
          {f.instructor_image && <img src={mediaUrl(f.instructor_image)} alt="" className="w-16 h-16 rounded-xl object-cover" />}
          <label className="cursor-pointer inline-flex items-center gap-2 text-sm px-3 py-2 rounded-xl bg-white/5 hover:bg-white/10"><Upload size={15} />صورة المدرب
            <input type="file" hidden accept="image/jpeg,image/png,image/webp" onChange={(e) => uploadImg(e.target.files[0])} data-testid="settings-instructor-image-input" />
          </label>
        </div>
      </Section>
    </div>
  );
}
